import React, { useState, useMemo } from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import CalendarSection from "./CalendarSection";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import {
  HojaDeTransportePorFecha,
  useObtenerTransportesPorFecha,
} from "../../../services/transporteServicios";
import EntradasSalidas from "./EntradasSalidas";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { obtenerStringDeFecha } from "../../../utils/dateUtils";

function MasterDetailSection() {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();
  const [detailAnimationParent] = useAutoAnimate<HTMLDivElement>();

  const {
    data: transportesPorFecha,
    isLoading: transportesPorFechaIsLoading,
    error: transportesPorFechaError,
    isSuccess: transportesPorFechaIsSuccess,
  } = useObtenerTransportesPorFecha();

  const hojasDeTransportePorFechaTiempo: Map<string, HojaDeTransportePorFecha> =
    useMemo(() => {
      if (transportesPorFecha) {
        const hojas: Map<string, HojaDeTransportePorFecha> = new Map<
          string,
          HojaDeTransportePorFecha
        >();
        transportesPorFecha.forEach((hoja, fecha) => {
          hojas.set(obtenerStringDeFecha(fecha), hoja);
        });
        return hojas;
      } else {
        return new Map<string, HojaDeTransportePorFecha>();
      }
    }, [transportesPorFecha]);

  const [fechaSeleccionada, setFechaSeleccionada] = useState<Date | undefined>(
    undefined
  );

  const [mostrarCalendario, setMostrarCalendario] = useState<
    boolean | undefined
  >(undefined);

  const hojaDeTransporte = useMemo(() => {
    if (fechaSeleccionada) {
      return hojasDeTransportePorFechaTiempo.get(
        obtenerStringDeFecha(fechaSeleccionada)
      );
    } else {
      return undefined;
    }
  }, [fechaSeleccionada, hojasDeTransportePorFechaTiempo]);

  const onFechaSeleccionada = (date: Date) => {
    setFechaSeleccionada(date);
    setMostrarCalendario(false);
  };

  const toggleMostrarCalendario = (mostrar: boolean) => {
    setMostrarCalendario(mostrar);
  };

  const isLoading = transportesPorFechaIsLoading;
  const error = transportesPorFechaError;

  if (isLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  if (error) {
    return <ServerErrorModal />;
  }

  const debeMostrarCalendario =
    transportesPorFecha &&
    transportesPorFechaIsSuccess &&
    mostrarCalendario !== false;

  return (
    <>
      {debeMostrarCalendario && (
        <CalendarSection
          transportesPorFecha={transportesPorFecha!}
          onFechaSeleccionada={onFechaSeleccionada}
          debeMostrarCalendario={debeMostrarCalendario}
          toggleMostrarCalendario={toggleMostrarCalendario}
        />
      )}
      <StyledRow>
        <Col xxl={hojaDeTransporte ? "12" : "10"} sm="12">
          <Row ref={animationParent} className="justify-content-center">
            {hojaDeTransporte && (
              <Col sm="12" ref={detailAnimationParent}>
                <EntradasSalidas
                  hojaDeTransporte={hojaDeTransporte}
                  toggleMostrarCalendario={toggleMostrarCalendario}
                />
              </Col>
            )}
          </Row>
        </Col>
      </StyledRow>
    </>
  );
}

const StyledRow = styled(Row)`
  justify-content: center;
`;

export default MasterDetailSection;
